<div class="modal-content">
    <div class="modal-header">
        <h5 class="modal-title">Création de compte</h5>
        <button type="button" class="btn-close" (click)="modalServices.dismissAll()">
        </button>
    </div>
    <div class="modal-body">
        <ul class="nav nav-tabs" ngbNav #nav="ngbNav" [(activeId)]="active" class="nav-tabs">
            <li class="nav-item" [ngbNavItem]="1">
                <button class="tab-btn" ngbNavLink>Compte fan</button>
                <ng-template ngbNavContent>
                    <div class="container" style="padding: 20px;">
                        <div *ngIf="message.length > 0" class="alert alert-danger">
                            <ul>
                                <li *ngFor="let error of message">{{ error }}</li>
                            </ul>
                        </div>

                        <form class="theme-form" *ngIf="registerForm" [formGroup]="registerForm" (ngSubmit)="handleSubmitRegister($event)">
                            <!-- <input type="hidden" formControlName="rang"> -->
                            <div class="row">
                                <div class="col-lg-6">
                                    <div class="form-group">
                                        <label for="prenom">Prénom <span class="required">*</span></label>
                                        <input type="text" formControlName="prenom" class="form-control" id="prenom"
                                            placeholder="Votre Prénom" name="prenom">
                                    </div>
                                    <div class="form-error" *ngIf="isRegisterSubmited && registerFormControls!['prenom'].errors">
                                        <div class="form-error-item" *ngIf="isRegisterSubmited && registerFormControls!['prenom'].errors['required']">
                                            Veuillez remplir le champ prenom
                                        </div>
                                    </div>
                                </div>

                                <div class="col-lg-6">
                                    <div class="form-group">
                                        <label for="name">Nom <span class="required">*</span></label>
                                        <input type="text" formControlName="name" class="form-control" id="name"
                                            placeholder="Votre nom de famille" name="name">
                                    </div>
                                    <div class="form-error" *ngIf="isRegisterSubmited && registerFormControls!['name'].errors">
                                        <div class="form-error-item" *ngIf="isRegisterSubmited && registerFormControls!['name'].errors['required']">
                                            Veuilez remplir le champ Nom
                                        </div>
                                    </div>
                                </div>
                            </div>  
                            <div class="row">
                                <div class="col-lg-6">
                                    <div class="form-group phone-group">
                                        <label for="telephone">Téléphone <span class="required">*</span></label>
                                        <div class="phone-input-group">
                                            <div class="country-select-wrapper">
                                                <div class="country-select-header" (click)="toggleCountrySelect()">
                                                    <span class="selected-country">
                                                    <img [src]="selectedCountry?.flag ? 'assets/svg/' + selectedCountry.flag : 'assets/svg/flags/cd.svg'" 
                                                     [alt]="selectedCountry?.name || 'Country'" 
                                                     class="flag-icon" 
                                                     style="width: 20px; height: 20px; margin-right: 8px;">
                                                   <span class="country-code">+{{ selectedCountry?.codetelephonique?.replace('+', '') || selectedCountry?.phone_code?.replace('+', '') || '243' }}</span>
                                                     </span>
                                    <i class="fas" [ngClass]="{'fa-chevron-down': !isCountrySelectOpen, 'fa-chevron-up': isCountrySelectOpen}"></i>
                                                </div>
                                                <div class="country-select-dropdown" *ngIf="isCountrySelectOpen">
                                                    <div class="search-box">
                                                        <i class="fas fa-search"></i>
                                                        <input type="text" 
                                                               formControlName="countrySearch"
                                                               [ngModel]="countrySearch"
                                                               (ngModelChange)="countrySearch = $event; filterCountries()"
                                                               placeholder="Rechercher un pays..."
                                                               class="search-input">
                                                    </div>
                                                    <div class="country-list">
                                                        <div class="country-item" 
                                                             *ngFor="let country of filteredCountries" 
                                                             (click)="selectCountry(country)">
                                                            <img [src]="country.flag && country.flag.trim() ? 'assets/svg/' + country.flag : 'assets/svg/flags/cd.svg'" 
                                                             [alt]="country.name" 
                                                             class="flag-icon" 
                                                             style="width: 20px; height: 20px; margin-right: 8px;">
                                                            <span class="country-name">{{ country.name }}</span>
                                                            <span class="country-code">{{ country.codetelephonique || country.phone_code }}</span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <input type="tel"
                                                   formControlName="telephone"
                                                   class="form-control"
                                                   id="telephone"
                                                   placeholder="812345678"
                                                   name="telephone" [maxlength]="getPhoneMaxLength(selectedCountry)"
                                                   (input)="onPhoneInput($event, registerForm)" />
                                            <p class="text-danger" *ngIf="isRegisterSubmited && registerForm.get('telephone')?.invalid && (registerForm.get('telephone')?.dirty || registerForm.get('telephone')?.touched)">
                                                {{ getPhoneValidationHint(selectedCountry) }}
                                            </p>
                                        </div>
                                    </div>
                                    <div class="form-error" *ngIf="isRegisterSubmited && registerFormControls!['telephone'].errors">
                                        <div class="form-error-item" *ngIf="isRegisterSubmited && registerFormControls!['telephone'].errors['required']">
                                            Veuillez remplir le champ Téléphone
                                        </div>
                                    </div>
                                </div>

                                <div class="col-lg-6">
                                    <div class="form-group">
                                        <label for="email">Adresse mail <span class="required">*</span></label>
                                        <input type="email" formControlName="email" class="form-control" id="email"
                                            placeholder="Votre adresse mail" name="email">
                                    </div>
                                    <div class="form-error" *ngIf="isRegisterSubmited && registerFormControls!['email'].errors">
                                        <div class="form-error-item" *ngIf="isRegisterSubmited && registerFormControls!['email'].errors['required']">
                                            Veuillez remplir le champ mail
                                        </div>
                                        <div class="form-error-item" *ngIf="isRegisterSubmited && registerFormControls!['email'].errors['email']">
                                            L'adresse mail est invalide
                                        </div>
                                    </div>
                                </div>
                            </div>  
                            <div class="row">
                                <div class="col-lg-12">
                                    <div class="form-group">
                                        <label for="username">Nom d'utilisateur</label>
                                        <input type="text" formControlName="username" class="form-control" id="username"
                                            placeholder="Votre nom d'utilisateur" name="username" autocomplete="off">
                                        
                                        <div class="form-error" *ngIf="(isRegisterSubmited || registerForm.get('username')?.touched) && registerForm.get('username')?.errors">
                                            <div class="form-error-item" *ngIf="registerForm.get('username')?.errors?.['hasSpaces']">
                                                Le nom d'utilisateur ne doit pas contenir d'espaces
                                            </div>
                                            <div class="form-error-item" *ngIf="registerForm.get('username')?.errors?.['usernameTaken']">
                                                Ce nom d'utilisateur est déjà utilisé
                                            </div>
                                        </div>
                                        
                                        <div class="mb-3" *ngIf="usernameSuggestions.length > 0">
                                            <small class="text-muted">Suggestions disponibles :</small>
                                            <div class="d-flex flex-wrap gap-2 mt-1">
                                                <span class="badge bg-light text-dark border"
                                                      style="cursor: pointer;"
                                                      *ngFor="let suggestion of usernameSuggestions"
                                                      (click)="selectSuggestion(suggestion, 'fan')">
                                                    {{ suggestion }}
                                                </span>
                                            </div>
                                        </div>
                                    </div>

                                </div>
                            </div>
                            <div class="row">
                                <div class="col-lg-6">
                                    <div class="form-group">
                                        <label for="exampleInputPassword1">Mot de passe <span class="required">*</span></label>
                                        <div class="password-input-group">
                                            <input [type]="showPassword ? 'text' : 'password'" class="form-control" formControlName="password" id="exampleInputPassword1"
                                                placeholder="Password" name="password">
                                                @if(showPassword) {
                                                    <app-feather-icon [icons]="'eye-off'" [class]="'input-icon iw-20 ih-20'" (click)="togglePasswordVisibility()" style="cursor: pointer;"></app-feather-icon>
                                                } @else {
                                                    <app-feather-icon [icons]="'eye'" [class]="'input-icon iw-20 ih-20'" (click)="togglePasswordVisibility()" style="cursor: pointer;"></app-feather-icon>
                                                }
                                        </div>
                                    </div>
                                    <div class="form-error" *ngIf="isRegisterSubmited && registerForm.controls['nationalite_id'].errors">
                                        <div class="form-error-item" *ngIf="registerForm.controls['nationalite_id'].hasError('required')">
                                            Veuillez remplir le champ pays
                                        </div>
                                    </div>
                                </div>
                                
                                <div class="col-lg-6">
                                    <div class="form-group">
                                        <label for="password_confirmation">Confirmer votre mot de passe <span class="required">*</span></label>
                                        <div class="password-input-group">
                                            <input [type]="showPasswordConfirmation ? 'text' : 'password'" class="form-control" formControlName="password_confirmation" id="password_confirmation"
                                                placeholder="password confirmation" name="password_confirmation">
                                                @if(showPasswordConfirmation) {
                                                    <app-feather-icon [icons]="'eye-off'" [class]="'input-icon iw-20 ih-20'" (click)="togglePasswordConfirmationVisibility()" style="cursor: pointer;"></app-feather-icon>
                                                } @else {
                                                    <app-feather-icon [icons]="'eye'" [class]="'input-icon iw-20 ih-20'" (click)="togglePasswordConfirmationVisibility()" style="cursor: pointer;"></app-feather-icon>
                                                }
                                        </div>
                                        <div class="form-error" *ngIf="isRegisterSubmited && registerForm.hasError('passwordsMismatch') && (registerForm.get('password_confirmation')?.dirty || registerForm.get('password_confirmation')?.touched)">
                                            <div class="form-error-item">
                                                Les mots de passe ne correspondent pas.
                                            </div>
                                        </div>
                                        <div class="form-error" *ngIf="isRegisterSubmited && registerFormControls!['password_confirmation'].errors">
                                            <div class="form-error-item" *ngIf="isRegisterSubmited && registerFormControls!['password_confirmation'].errors['required']">
                                                Le champs de confirmation de mot de passe est requis
                                            </div>
                                            <div class="form-error-item" *ngIf="isRegisterSubmited && registerFormControls!['password_confirmation'].errors['minLength']">
                                                Le mot de passe de confirmation est court
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>  
                            <!-- <div class="row">
                                <div class="col-lg-12">
                                    <div class="form-group">
                                        <label for="exampleInputPassword1">Pays</label>
                                        <select formControlName="nationalite_id" class="form-select" aria-label="Default select example" style="height: 50px;">
                                            <option selected>Selectionnez votre pays</option>
                                            <option *ngFor="let option of nationalities" [value]="option.id">
                                                {{ option.name }}
                                            </option>
                                        </select>
                                    </div>
                                </div>
                            </div> -->
                            <!-- <div class="row last-row">
                                <div class="col-lg-12">
                                    <label class="d-block mb-2 fw-bold">Préférences de notification :</label>
                                </div>
                               <div class="col-lg-6">
                                    <div class="form-group">
                                        <label class="notif-option">
                                            <input type="radio" formControlName="notification" value="email">
                                            <div class="notif-content">
                                                <span>Je veux être notifié par email</span>
                                            </div>
                                        </label>    
                                    </div>
                                </div>                                   
                                <div class="col-lg-6">
                                    <div class="form-group">
                                            <label class="notif-option">
                                                <input type="radio" formControlName="notification" value="sms">
                                                <div class="notif-content">
                                                    <span>Je veux être notifié par SMS</span>
                                                </div>
                                            </label>
                                    </div>
                                </div>    
                            </div> -->

                            <!-- RGPD Checkbox pour le formulaire Fan -->
                            <div class="rgpd-container">
                                <div class="rgpd-title">Protection des données personnelles</div>
                                <div class="rgpd-text">
                                    En créant votre compte, vous acceptez que vos informations soient utilisées de manière sécurisée et confidentielle.
                                </div>
                                <div class="form-check">
                                    <input type="checkbox" class="form-check-input" id="rgpdCheck" style="margin-left: 1px;" formControlName="rgpdConsent">
                                    <label class="form-check-label" for="rgpdCheck">
                                        J'accepte que mes données personnelles soient collectées et traitées conformément à la 
                                        <a href="/#/privacy-policy" target="_blank">politique de confidentialité</a> et au RGPD.
                                    </label>
                                </div>
                                <div class="form-error" *ngIf="isRegisterSubmited && registerFormControls!['rgpdConsent'].errors">
                                    <div class="form-error-item" *ngIf="isRegisterSubmited && registerFormControls!['rgpdConsent'].errors['required']">
                                        Vous devez accepter la politique de confidentialité pour continuer
                                    </div>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-12 mb-3">
                                    <re-captcha
                                        [siteKey]="siteKey"
                                        (resolved)="handleCaptchaResponse($event)"
                                    ></re-captcha>
                                </div>
                            </div>

                            <div class="btn-section mt-3 d-flex justify-content-end">
                                <button class="btn btn-solid btn-lg" [disabled]="isLoading">
                                    <span *ngIf="isLoading" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                                    <span *ngIf="!isLoading">Créer compte</span>
                                </button>
                            </div>  
                        </form>                     
                    </div>
                </ng-template>
            </li>
            <li class="nav-item" [ngbNavItem]="2">
                <button class="tab-btn" ngbNavLink>Compte célébrité</button>
                <ng-template ngbNavContent>
                    <div class="container" style="padding: 20px;">
                        <div *ngIf="message.length > 0" class="alert alert-danger">
                            <ul>
                                <li *ngFor="let error of message">{{ error }}</li>
                            </ul>
                        </div>
                        
                        <form class="theme-form" *ngIf="registerForm2" [formGroup]="registerForm2" (ngSubmit)="handleSubmitRegister2($event)">
                            <!-- <input type="hidden" formControlName="rang"> -->
                            <div class="row">
                                <div class="col-lg-6">
                                    <div class="form-group">
                                        <label for="exampleInputPassword1">Domaine</label>
                                        <select formControlName="domain_id" class="form-select" aria-label="Default select example" style="height: 50px;">
                                            <option value="0" selected>Selectionnez votre domaine</option>
                                            <option *ngFor="let option of domains" [value]="option.id">
                                                {{ option.name }}
                                            </option>
                                        </select>
                                    </div>
                                    <div class="form-error" *ngIf="isRegisterSubmited2 && registerFormControls2!['domain_id'].errors">
                                        <div class="form-error-item" *ngIf="isRegisterSubmited2 && registerFormControls2!['domain_id'].errors['required']">
                                            Veuillez remplir le champ domaine
                                        </div>
                                    </div>
                                </div>
                                <div class="col-lg-6">
                                    <div class="form-group">
                                        <label for="prenom">Nom de Scene</label>
                                        <input type="text" formControlName="scene_name" class="form-control" id="scene_name"
                                            placeholder="Votre nom de Scene" name="scene_name">
                                    </div>
                                    <div class="form-error" *ngIf="isRegisterSubmited2 && registerFormControls2!['scene_name'].errors">
                                        <div class="form-error-item" *ngIf="isRegisterSubmited2 && registerFormControls2!['scene_name'].errors['required']">
                                            Le nom de Scene est requis
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-lg-6">
                                    <div class="form-group">
                                        <label for="prenom">Prénom</label>
                                        <input type="text" formControlName="prenom" class="form-control" id="prenom"
                                            placeholder="Votre Prénom" name="prenom">
                                    </div>
                                    <div class="form-error" *ngIf="isRegisterSubmited2 && registerFormControls2!['prenom'].errors">
                                        <div class="form-error-item" *ngIf="isRegisterSubmited2 && registerFormControls2!['prenom'].errors['required']">
                                            Veuillez remplir le champ prenom
                                        </div>
                                    </div>
                                </div>

                                <div class="col-lg-6">
                                    <div class="form-group">
                                        <label for="name">Nom</label>
                                        <input type="text" formControlName="name" class="form-control" id="name"
                                            placeholder="Votre nom de famille" name="name">
                                    </div>
                                    <div class="form-error" *ngIf="isRegisterSubmited2 && registerFormControls2!['name'].errors">
                                        <div class="form-error-item" *ngIf="isRegisterSubmited2 && registerFormControls2!['name'].errors['required']">
                                            Veuilez remplir le champ Nom
                                        </div>
                                    </div>
                                </div>
                            </div>  
                            <div class="row">
                                <div class="col-lg-6">
                                    <div class="form-group phone-group">
                                        <label for="telephone">Téléphone</label>
                                        <div class="phone-input-group">
                                            <div class="country-select-wrapper">
                                                <div class="country-select-header" (click)="toggleCountrySelect()">
                                                    <span class="selected-country">
                                                <img [src]="selectedCountry2?.flag ? 'assets/svg/' + selectedCountry2.flag : 'assets/svg/flags/cd.svg'" 
                                                     [alt]="selectedCountry2?.name || 'Country'" 
                                                     class="flag-icon" 
                                                     style="width: 20px; height: 20px; margin-right: 8px;">
                                                <span class="country-code">+{{ selectedCountry2?.codetelephonique?.replace('+', '') || selectedCountry2?.phone_code?.replace('+', '') || '243' }}</span>
                                                </span>
                                               <i class="fas" [ngClass]="{'fa-chevron-down': !isCountrySelectOpen, 'fa-chevron-up': isCountrySelectOpen}"></i>
                                                </div>
                                                <div class="country-select-dropdown" *ngIf="isCountrySelectOpen">
                                                    <div class="search-box">
                                                        <i class="fas fa-search"></i>
                                                        <input type="text" 
                                                               formControlName="countrySearch"
                                                               [ngModel]="countrySearch"
                                                               (ngModelChange)="countrySearch = $event; filterCountries()"
                                                               placeholder="Rechercher un pays..."
                                                               class="search-input">
                                                    </div>
                                                    <div class="country-list">
                                                        <div class="country-item" 
                                                             *ngFor="let country of filteredCountries" 
                                                             (click)="selectCountry2(country)">
                                                            <img [src]="country.flag && country.flag.trim() ? 'assets/svg/' + country.flag : 'assets/svg/flags/cd.svg'" 
                                                             [alt]="country.name" 
                                                             class="flag-icon" 
                                                             style="width: 20px; height: 20px; margin-right: 8px;">
                                                            <span class="country-name">{{ country.name }}</span>
                                                            <span class="country-code">+{{ country.codetelephonique?.replace('+', '') || country.phone_code?.replace('+', '') || '243' }}</span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <input type="tel"
                                                   formControlName="telephone"
                                                   class="form-control"
                                                   id="telephone"
                                                   placeholder="812345678"
                                                   name="telephone" [maxlength]="getPhoneMaxLength(selectedCountry2)"
                                                   (input)="onPhoneInput2($event)" />
                                            <p class="text-danger" *ngIf="isRegisterSubmited2 && registerForm2.get('telephone')?.invalid && (registerForm2.get('telephone')?.dirty || registerForm2.get('telephone')?.touched)">
                                                {{ getPhoneValidationHint(selectedCountry2) }}
                                            </p>
                                        </div>
                                    </div>
                                    <div class="form-error" *ngIf="isRegisterSubmited2 && registerFormControls2!['telephone'].errors">
                                        <div class="form-error-item" *ngIf="isRegisterSubmited2 && registerFormControls2!['telephone'].errors['required']">
                                            Veuillez remplir le champ Téléphone
                                        </div>
                                    </div>
                                </div>

                                <div class="col-lg-6">
                                    <div class="form-group">
                                        <label for="email">Adresse mail</label>
                                        <input type="email" formControlName="email" autocomplete="off" class="form-control" id="email"
                                            placeholder="Votre adresse mail" name="email">
                                    </div>
                                    <div class="form-error" *ngIf="isRegisterSubmited2 && registerFormControls2!['email'].errors">
                                        <div class="form-error-item" *ngIf="isRegisterSubmited2 && registerFormControls2!['email'].errors['required']">
                                            Veuillez remplir le champ mail
                                        </div>
                                        <div class="form-error-item" *ngIf="isRegisterSubmited2 && registerFormControls2!['email'].errors['email']">
                                            L'adresse mail est invalide
                                        </div>
                                    </div>
                                </div>
                            </div>  

                            <div class="row">
                                <div class="col-lg-12">
                                    <div class="form-group">
                                        <label for="username">Nom d'utilisateur</label>
                                        <input type="text" formControlName="username" autocomplete="off" class="form-control" id="username"
                                            placeholder="Votre nom d'utilisateur" name="username">
                                    </div>

                                    <div class="form-error" *ngIf="(isRegisterSubmited2 || registerForm2.get('username')?.touched) && registerForm2.get('username')?.errors">
                                        <div class="form-error-item" *ngIf="registerForm2.get('username')?.errors?.['hasSpaces']">
                                            Le nom d'utilisateur ne doit pas contenir d'espaces
                                        </div>
                                        <div class="form-error-item" *ngIf="registerForm2.get('username')?.errors?.['usernameTaken']">
                                            Ce nom d'utilisateur est déjà utilisé
                                        </div>
                                    </div>

                                    <div class="mt-2" *ngIf="usernameSuggestions2.length > 0">
                                        <small class="text-muted">Suggestions disponibles :</small>
                                        <div class="d-flex flex-wrap gap-2 mt-1">
                                            <span class="badge bg-light text-dark border"
                                                  style="cursor: pointer;"
                                                  *ngFor="let suggestion of usernameSuggestions2"
                                                  (click)="selectSuggestion(suggestion, 'star')">
                                                {{ suggestion }}
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            
                            <div class="row">
                                <div class="col-lg-6">
                                    <div class="form-group">
                                        <label for="password">Mot de passe</label>
                                        <div class="password-input-group">
                                            <input [type]="showPassword2 ? 'text' : 'password'" autocomplete="off" class="form-control" formControlName="password" id="password"
                                                placeholder="Votre mot de passe" name="password">
                                                @if(showPassword2) {
                                                    <app-feather-icon [icons]="'eye-off'" [class]="'input-icon iw-20 ih-20'" (click)="togglePasswordVisibility2()" style="cursor: pointer;"></app-feather-icon>
                                                } @else {
                                                    <app-feather-icon [icons]="'eye'" [class]="'input-icon iw-20 ih-20'" (click)="togglePasswordVisibility2()" style="cursor: pointer;"></app-feather-icon>
                                                }
                                        </div>
                                    </div>
                                    <div class="form-error" *ngIf="isRegisterSubmited2 && registerFormControls2!['password'].errors">
                                        <div class="form-error-item" *ngIf="isRegisterSubmited2 && registerFormControls2!['password'].errors['required']">
                                            Mot de passe est requis
                                        </div>
                                        <div class="form-error-item" *ngIf="isRegisterSubmited2 && registerFormControls2!['password'].errors['minLength']">
                                            Mot de passe est court
                                        </div>
                                    </div>
                                </div>
                                
                                <div class="col-lg-6">
                                    <div class="form-group">
                                        <label for="password_confirmation">Confirmer votre mot de passe</label>
                                        <div class="password-input-group">
                                            <input [type]="showPasswordConfirmation2 ? 'text' : 'password'" autocomplete="off" class="form-control" formControlName="password_confirmation" id="password_confirmation"
                                                placeholder="password confirmation" name="password_confirmation">
                                                @if(showPasswordConfirmation2) {
                                                    <app-feather-icon [icons]="'eye-off'" [class]="'input-icon iw-20 ih-20'" (click)="togglePasswordConfirmationVisibility2()" style="cursor: pointer;"></app-feather-icon>
                                                } @else {
                                                    <app-feather-icon [icons]="'eye'" [class]="'input-icon iw-20 ih-20'" (click)="togglePasswordConfirmationVisibility2()" style="cursor: pointer;"></app-feather-icon>
                                                }
                                        </div>
                                    </div>
                                    <div class="form-error" *ngIf="isRegisterSubmited2 && registerFormControls2!['password_confirmation'].errors">
                                        <div class="form-error-item" *ngIf="isRegisterSubmited2 && registerFormControls2!['password_confirmation'].errors['required']">
                                            Mot de passe de confirmation est requis
                                        </div>
                                        <div class="form-error-item" *ngIf="isRegisterSubmited2 && registerFormControls2!['password_confirmation'].errors['minLength']">
                                            Mot de passe de confirmation est court
                                        </div>
                                    </div>
                                </div>
                            </div>  
                            <div class="row">
                                <div class="col-lg-12">
                                    <div class="form-group">
                                        <label for="exampleInputPassword1">Pays <span class="required">*</span></label>
                                        <select formControlName="nationalite_id" class="form-select" aria-label="Default select example" style="height: 50px;">
                                            <option selected>Selectionnez votre pays</option>
                                            <option *ngFor="let option of nationalities" [value]="option.id">
                                                {{ option.name }}
                                            </option>
                                        </select>
                                    </div>
                                    <!-- <div class="form-error" *ngIf="isRegisterSubmited && registerFormControls?.['nationalite_id']?.errors">
                                        <div class="form-error-item" *ngIf="isRegisterSubmited && isRegisterSubmited!['nationalite_id'].errors['required']">
                                            Veuillez remplir le champ pays
                                        </div>
                                    </div> -->
                                </div>
                            </div>
                            <!-- <div class="row last-row">
                                <div class="col-lg-12">
                                    <label class="d-block mb-2 fw-bold">Préférences de notification :</label>
                                </div>
                               <div class="col-lg-6">
                                    <div class="form-group">
                                        <label class="notif-option">
                                            <input type="radio" formControlName="notification" value="email">
                                            <div class="notif-content">
                                                <span>Je veux être notifié par email</span>
                                            </div>
                                        </label>    
                                    </div>
                                </div>                                   
                                <div class="col-lg-6">
                                    <div class="form-group">
                                            <label class="notif-option">
                                                <input type="radio" formControlName="notification" value="sms">
                                                <div class="notif-content">
                                                    <span>Je veux être notifié par SMS</span>
                                                </div>
                                            </label>
                                    </div>
                                </div>    
                            </div> -->

                            <!-- RGPD Checkbox pour le formulaire Célébrité -->
                            <div class="rgpd-container">
                                <div class="rgpd-title">Protection des données personnelles</div>
                                <div class="rgpd-text">
                                    En créant votre compte célébrité, vous acceptez que vos informations soient utilisées de manière sécurisée et confidentielle.
                                </div>
                                <div class="form-check">
                                    <input type="checkbox" class="form-check-input" id="rgpdCheck2" formControlName="rgpdConsent">
                                    <label class="form-check-label" for="rgpdCheck2">
                                        J'accepte que mes données personnelles soient collectées et traitées conformément à la 
                                        <a href="/privacy-policy" target="_blank">politique de confidentialité</a> et au RGPD.
                                    </label>
                                </div>
                                <div class="form-error" *ngIf="isRegisterSubmited2 && registerFormControls2!['rgpdConsent'].errors">
                                    <div class="form-error-item" *ngIf="isRegisterSubmited2 && registerFormControls2!['rgpdConsent'].errors['required']">
                                        Vous devez accepter la politique de confidentialité pour continuer
                                    </div>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-12 mb-3">
                                    <re-captcha
                                        [siteKey]="siteKey"
                                        (resolved)="handleCaptchaResponse($event)"
                                    ></re-captcha>
                                </div>
                            </div>

                            <div class="btn-section mt-3 d-flex justify-content-end">
                                <button class="btn btn-default" (click)="modalServices.dismissAll()">Fermer</button>
                                <button class="btn btn-solid btn-lg" [disabled]="isLoading">
                                    <span *ngIf="isLoading" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                                    <span *ngIf="!isLoading">Créer compte</span>
                                </button>
                            </div>  
                        </form>
                    </div>
                </ng-template>
            </li>
        </ul>
        <div [ngbNavOutlet]="nav" class="mt-2"></div>
    </div>
</div>

 
